var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-integer"},[_c('BaseInput',{attrs:{"data-vv-as":_vm.field.type,"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"type":"number","step":"1","hint":_vm.hint,"validate":_vm.validator(),"prefix":_vm.subFormData.prefix,"suffix":_vm.subFormData.suffix,"minVal":+_vm.subFormData.min,"maxVal":+_vm.subFormData.max || Infinity},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-587d8fc8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditInteger.vue
// module id = 649
// module chunks = 0